import React from "react";
import { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LuFilterX } from "react-icons/lu";
import StyledTooltip from "../shared/toolTip/StyledTooltip";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import { deleteTags, restoreTags } from "../redux/project/projActions";
import { AgGridReact } from "ag-grid-react";
import { LinearProgress } from '@mui/material';
import { fetchArchiveCancelAct } from "../redux/project/projActions";
import { agGridTrans } from "../translation/i18n";
import { useTranslation } from 'react-i18next';
import { getAgGridIndexofSelectedRows, statusBar } from "../../utils";
// import { use } from "i18next";

// Rest of the code...

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
    //  cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}


const DeleteTag = (props) => {
  let cldf = props.columnDefs;
  const [delClickEnabled, setDelClickEnabled] = useState(false);
  const [openDelConfirm, setOpenDelConfirm] = useState(false);
  const [multiRowPL, setmultiRowPL] = useState([]);
  const [deleteTag, setDeleteTag] = useState([]);
  const [restoreTag, setrestoreTag] = useState([]);
  const [haveACtTags, setHaveACtTags] = useState(false);
  const [openArchive, setOpenArchive] = useState(false);
  const [restoreActive, setRestoreActive] = useState(false);
  const [columnDF, setColumnDF] = useState(cldf);
  const [selectedDeletedData, setSelectedDeletedData] = useState([]);
  const prof = useSelector(state => state.profile);
  const { t, i18n } = useTranslation();
  const wsTabValue = useSelector((state) => state.ctrl.wsTabValue);
  const isInstrumentationTab = wsTabValue === 'Instrumentation' ? true : false;
  const commercialTypes = useSelector((state) => state.ctrl.commercialTypes);
  const allTags = useSelector((state) => state.project.tags);
  

  let deletedTags = useSelector((state) =>
    // state.project.deletedTags.filter((o) => o.selected === "Y")
    state.project.deletedTags.filter((tag) =>
      !isInstrumentationTab
        ? tag.gen_technology_type === wsTabValue
        : !commercialTypes.includes(tag.gen_technology_type)
    )
    .filter((o) => o.selected === "Y")
  );
  const project = useSelector((state) => state.project);

  // console.log("projectproject", project.phase)

  let selectedRows = props.selectedRows;
  const dispatch = useDispatch();
  let deleteLimit = 100;

  // console.log("props.showProgressBar", props.showProgressBar)
  useEffect(() => {
    if (!props.showProgressBar) {
      // if(!props.tagsLoaded){
      //   setTimeout(() => {
      //     props.setTagsLoaded(true);
      //   }, 2500);
      // }
      if (openArchive) {
        setSelectedDeletedData([]);
        props.selectedDeletedData([]);
      }
      
    }
  }, [props.showProgressBar])



  const getDelClick = () => {
    let restoreEnableNW = true;
    if (!selectedDeletedData || (selectedDeletedData && selectedDeletedData?.length === 0 && props.clickFrom === "Restore")) {
      toastr.error(t('Please Select the Tag line'));
    }

    if ((!selectedRows && props.clickFrom === "Delete") || (selectedRows && selectedRows?.length === 0 && props.clickFrom === "Delete")) {
      toastr.error(t('Please Select the Tag line'));
      setOpenDelConfirm(false);
    }
    if (selectedRows && selectedRows.length > 0) {
      if (openArchive) {
        let haveActiveTag = false;
        let alreadyTagTEMP = [];
        // props.rowData.map((tag) => {
        //   if (tag.tag_enabled == "Y") {
        //     alreadyTagTEMP.push(tag.tag_number.toLowerCase());
        //   }
        // });
        allTags.map((tag) => {
          if (tag.tag_enabled == "Y") {
            alreadyTagTEMP.push(tag.tag_number.toLowerCase());
          }
        });
        let getSelectedTagNumber = [];
        selectedRows.map((item) => {
          if (!getSelectedTagNumber.includes(item.tag_number.toLowerCase())) {
            getSelectedTagNumber.push(item.tag_number.toLowerCase());
          } else {
            toastr.error(t('Multiple tags with same Tag Number') + " " + item.tag_number + " " + t('is selected to Restore, Please select unique Tag Number for restoring'));
            setOpenDelConfirm(false);
            restoreEnableNW = false;
          }
        })
        selectedRows.map((delTag) => {
          if (
            alreadyTagTEMP.includes(delTag.tag_number.toLowerCase()) &&
            delTag.tag_enabled == "N"
          ) {
            toastr.error(t('Tag') + " " + delTag.tag_number + " " + t('is already active,') + " " + t('Please update already active Tag Number to restore the Deleted') + " " + delTag.tag_number + " " + t('tag'));
            setOpenDelConfirm(false);
            restoreEnableNW = false;
          }
        });
        selectedRows.map((tag) => {
          if (tag.tag_enabled === "Y") {
            haveActiveTag = true;
          }
        });
        setHaveACtTags(haveActiveTag);
      }
      if (props.clickFrom === "Delete") {
        const commercialTags = project.tags.filter(tag => commercialTypes.includes(tag.gen_technology_type) && tag.gen_rel_tag);
        
        const hasLinkedCommercialTags = selectedRows.some(tag => 
          commercialTags.some(comTag => comTag.gen_rel_tag.includes(tag.tag_id))
        );

        if (commercialTags.length > 0 && hasLinkedCommercialTags) {
          toastr.error(t('Cannot delete as some of the tags are linked to a commercial tag. Please unlink the tags and try again.'));
          setOpenDelConfirm(false);
        } else {
          setOpenDelConfirm(true);
        }
      }
      if (props.clickFrom === "Restore" && restoreEnableNW && selectedDeletedData.length > 0) {
        setOpenDelConfirm(true);
      }
    }
  };

  useEffect(() => {
    if (!delClickEnabled) {
      setDelClickEnabled(true);
    }

    if (delClickEnabled) {
      getDelClick();
    }
  }, [props.delClick]);

  const closeDelConfirm = () => {
    setOpenDelConfirm(false);
  };

  const multiRowPLLoad = (del) => {
    setDeleteTag([]);
    setmultiRowPL([]);
    setrestoreTag([]);
    let restoreCount = 0;
    if (props.clickFrom === "Delete") {
      selectedRows.slice(0, deleteLimit).map((rowItem) => {
        let rowItem2 = {};
        rowItem2.project_id = rowItem.project_id;
        rowItem2.package_id = rowItem.package_id;
        rowItem2.technology_id = rowItem.technology_id;
        rowItem2.revision = rowItem.revision;
        rowItem2.tag_id = rowItem.tag_id;
        rowItem2.tag_number = rowItem.tag_number;
        rowItem2.gen_technology_type = rowItem.gen_technology_type;
        rowItem2.tag_enabled = del;
        rowItem2.gen_rel_tag = "";
        setmultiRowPL((oldRow) => {
          return [...oldRow, rowItem2];
        });
        rowItem.tag_enabled = "N";
        rowItem.gen_rel_tag = ""
        setDeleteTag((oldID) => {
          return [...oldID, rowItem];
        });
      });
    }

    if (restoreActive) {
      let newSelectedRow = selectedDeletedData.filter(
        (item) => item.tag_enabled !== "Y"
      );
      newSelectedRow.slice(0, deleteLimit).map((rowItem) => {
        let rowItem2 = {};
        rowItem2.project_id = rowItem.project_id;
        rowItem2.package_id = rowItem.package_id;
        rowItem2.technology_id = rowItem.technology_id;
        rowItem2.revision = rowItem.revision;
        rowItem2.tag_id = rowItem.tag_id;
        rowItem2.tag_number = rowItem.tag_number;
        rowItem2.gen_technology_type = rowItem.gen_technology_type;
        rowItem2.tag_enabled = del;
        setmultiRowPL((oldRow) => {
          return [...oldRow, rowItem2];
        });
        setDeleteTag((oldID) => {
          return [...oldID, rowItem2.tag_id];
        });
        if (restoreActive) {
          restoreCount = restoreCount + 1;
          if (restoreCount <= deleteLimit) {
            rowItem.tag_enabled = "Y";
            setrestoreTag((oldTag) => {
              return [...oldTag, rowItem];
            });
          }
        }
      });
    }
    setOpenDelConfirm(false);
  };

  const onClickDelConfirm = () => {
    multiRowPLLoad("N");
  };

  const onClickRestoreConfirm = () => {
    multiRowPLLoad("Y");
  };

  useEffect(() => {
    if (multiRowPL.length > 0) {
      if (props.clickFrom === "Delete") {
        console.log(deleteTag.slice(0, deleteLimit), 'in del screen')
        dispatch(deleteTags(deleteTag.slice(0, deleteLimit)));
        props.resChild(
          "DeleteTags",
          multiRowPL.slice(0, deleteLimit),
          "tag_enabled"
        );
      }

      if (restoreActive) {
        setTimeout(() => {
          dispatch(restoreTags(restoreTag.slice(0, deleteLimit)));
        }, 3000);
        props.resChild("DeleteTags", multiRowPL.slice(0, deleteLimit), "tag_enabled");

        if (deleteTag.length === deletedTags.length) {
          setTimeout(() => {
            closeViewDeletedTags();
          }, 3000);
        }
      }
    }
  }, [multiRowPL]);

  const closeViewDeletedTags = () => {
    setSelectedDeletedData([]);
    props.selectedDeletedData([]);
    props.clickFromDeletedTag(false);
    setOpenArchive(false);
    setRestoreActive(false);
    if (props.showProgressBar) {
      dispatch(fetchArchiveCancelAct())
    }
  };

  const getRowStyle = useMemo(() => {
    return (params) => {
      if (params.data.tag_enabled === "N") {
        return {
          background: "#fcf3f3",
          color: "#ff0000",
        };
      }
    };
  }, [deletedTags]);

  const onSelectionChanged = (event) => {
    let getSortedRow = getAgGridIndexofSelectedRows(event.api.getSelectedNodes());

    setSelectedDeletedData(getSortedRow);
    props.selectedDeletedData(getSortedRow);
  };

  useEffect(() => {
    if ((project.phase === "INIT" || project.phase === "UPDATED") && props.restoreActive) {
      setTimeout(() => {
        setOpenArchive(true);
      }, 300);
    }
  }, [props.restoreActive, project.phase]);

  const restoreClicked = () => {
    setRestoreActive(true);
    getDelClick();
  };
 // clear filter 
  const [gridApi, setGridApi] = useState(null);
  const onGridReady = params => {
    setGridApi(params.api);
  };
  const clearFilters = () => {
    if (gridApi) {
      gridApi.setFilterModel(null);
    }
  };
  // clear filter
  useEffect(() => {
    if (cldf.length > 0) {
      let cldfCopy = JSON.parse(JSON.stringify(cldf));
      cldfCopy.map((columns) => {
        columns.children.map((child) => {
          child['editable'] = false;
        })
      })
      setColumnDF(cldfCopy);

      // if (columnDF.length === 0) {
      //   setColumnDF(cldfCopy);
      // }
      // if (prof?.bu !== 'Measurement Solutions') {
      //   setColumnDF(cldfCopy);
      // }
    }
  }, [cldf]);

  // console.log("tagsLoaded1", props.fetchtagPBarCount)
  // console.log("tagsLoaded2", project.ttlDataToBefetch)

  return (
    <>
      <Dialog
        open={openArchive}
        onClose={closeViewDeletedTags}
        className="viewDeletedTags-model muiForm-Modal"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle className="model-title mb-0 text-align-center">
          <div className="header-row">
            <div id="draggable-dialog-title" className="">
              {t('Archive screen')}
            </div>
           {/* clear filter */}
           <StyledTooltip title={'Clear Filters'} placement="bottom" disableInteractive>
            <label>           
              <LuFilterX
                className="tag-grid-head-cntrl mx-2"
                onClick={clearFilters}
                style={{ cursor: "pointer" }}
              />             
            </label>
            </StyledTooltip>
            {/* <span className="totalRec">{t('Total Deleted Tags:')}  {deletedTags.length} </span> */}
            {/* clear filter */}
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            className="ag-theme-alpine marginRow muiForm mb-2 pt-3"
            spacing={1.4}
          >
            <Grid item md={12} xs={12}>
              {(props.showProgressBar) &&
                <div sm={12} md={12} lg={12}>
                  <LinearProgress variant="determinate" value={props.fetchtagPBarCount || 0} />
                </div>}
              <div style={{ height: "65vh", position: "relative",pointerEvents: props.showProgressBar ? "none" : "auto",  opacity: props.showProgressBar ? 0.6 : 1, }}>
              { /*!props.tagsLoaded ? <div className="loadingx deleteTagLoading"
        // style={{ zIndex: '9999999', opacity: '1', width: "100%", position: 'absolute',
        // height: "70vh",
        // display: 'flex',
        // background: '#00000061'}}
        
        // open={open}
        // onClick={handleClose}
      >

        {/* <CircularProgress color="primary" style={{margin: 'auto'}}/> */}
      {/* </div> : null } */}
              {/* <div class="loadingx" style="margin: 7em"></div> <span class="ag-overlay-loading-center " style="font-size: 18px; z-index: 100000"> Loading Rows ...</span> */}
                <AgGridReact
                  statusBar={statusBar}
                  suppressRowClickSelection={props.showProgressBar ? true : false}
                  defaultColDef={props.defaultColDef}           
                  rowData={deletedTags}
                  localeText={agGridTrans[localStorage.getItem("lang")]}
                  columnDefs={columnDF}
                  headerHeight={30}
                  rowSelection={props.showProgressBar ? "none" : "multiple"}
                  rowHeight={26}
                  onSelectionChanged={onSelectionChanged}
                  getRowStyle={getRowStyle}  
                  onGridReady={onGridReady}               
                ></AgGridReact>
              </div>
            </Grid>
          </Grid>
            {/* <span className="totalRec">{t('Total Deleted Tags:')}  <b>{deletedTags.length} </b></span> */}
        
        </DialogContent>
        <DialogActions
          className="model-actions"
          style={{ paddingRight: "24px" }}
        >
          <button
            className="cnbtn btn cancel-btn"
            variant="outlined"
            onClick={closeViewDeletedTags}
          >
            {t('Close')}
          </button>
          <button disabled={props.showProgressBar} className="sbtn btn btn-secondary" onClick={restoreClicked}>
            <span> {t('Restore')} </span>
          </button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDelConfirm}
        onClose={closeDelConfirm}
        fullWidth
        maxWidth="sm"
        className="create-project tags-modal muiForm-Modal confirmModal"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle className="model-title" id="draggable-dialog-title">
          <div className="d-flex">
            <div> {t('Please Confirm')}  </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="pb-2 confirmModal-content pt-0">
            <p>
              {selectedRows?.length > deleteLimit && (
                <span>
                  {/* IF THE THAGS SELECTED ARE MORE THE 100 THIS WILL WORK */}
                  {t('You have selected more than')}    {deleteLimit} {t('tags.')}  {t('First')} {deleteLimit} {t('tags will be')}  {props.clickFrom === "Delete" && <> {t('deleted')} </>}{restoreActive && <> {t('restored')} </>}
                </span>
              )}
              {props.clickFrom === "Delete" && (
                <span>
                  {selectedRows?.length <= deleteLimit && (<span>
                    {/*FOR DELETING:- IF THE TAGE SELECTED FROM THE TAG GRID SCREEN
                     ARE LESS THAT 100 OR EQUAL TO 100 THIS WILL WORK */}
                    {t('The selected ')}
                    {selectedRows?.length > 1 ? t('tags') : t('tag')}
                    {t(' will be deleted')}

                  </span>)} {t('from the current Revision only.')}
                  {
                    !isInstrumentationTab && <span> {t('Related Tag data will also be deleted.')} </span>
                  }
                </span>
              )}

              {restoreActive && (
                <span>
                  {selectedRows?.length <= deleteLimit && (<span>
                    {/*FOR RESTORING:- IF THE TAGE SELECTED FROM POPUP 
                     ARE LESS THAT 100 OR EQUAL TO 100 THIS WILL WORK */}
                    {t('The selected ')}
                    {selectedRows?.length > 1 ? t('Tags') : t('Tag')}
                    {t(' will be restored')}

                  </span>)} {t('to the current Revision only.')}

                </span>
              )}
              {selectedRows?.length < deleteLimit && <br></br>}
              <span> {t('Do you want to proceed?')} </span>
            </p>
          </div>
        </DialogContent>
        <DialogActions
          className="copy-project-model-footer"
          style={{ paddingRight: "16px" }}
        >
          <Button outline color="success" onClick={closeDelConfirm}>
            {t('Cancel')}
          </Button>
          {props.clickFrom === "Delete" && (
            <Button
              className="sbtn btn btn-secondary"
              onClick={onClickDelConfirm}
            >
              <span>  {t('Delete')} </span>
            </Button>
          )}

          {restoreActive && (
            <Button
              className="sbtn btn btn-secondary"
              onClick={onClickRestoreConfirm}
            >
              <span> {t('Restore')} </span>
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteTag;
